import React, { useContext } from 'react';
import { Button } from 'antd';

import GlobalContactsContainer from '@totem/components/administration/globalContacts/GlobalContactsContainer';
import GlobalContactsContext from '@totem/components/administration/globalContacts/GlobalContactsContext';
import GlobalContactsFormModal from '@totem/components/administration/globalContacts/GlobalContactsFormModal';
import GlobalContactsTable from '@totem/components/administration/globalContacts/GlobalContactsTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

export const GlobalContactsContent = () => {
  const { openCreateModal, saving } = useContext(GlobalContactsContext);

  return (
    <>
      <IBCard
        isCovered
        title={'Global Contacts'}
        extra={
          <Button type="primary" onClick={openCreateModal} loading={saving}>
            Add Contact
          </Button>
        }
      >
        <GlobalContactsTable />
      </IBCard>
      <GlobalContactsFormModal />
    </>
  );
};

const GlobalContactsPage = () => (
  <GlobalContactsContainer>
    <ContentLayout>
      <GlobalContactsContent />
    </ContentLayout>
  </GlobalContactsContainer>
);

export default GlobalContactsPage;
